<template>
    <div class="panel-body">
     <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
        <b-row class="descargarexcel">
            <b-col offset="10">

                <b-button @click="descargar()" class="boton-busccar botonexcel">
                    <b-icon class="iconoexcel" icon="file-earmark-excel" aria-hidden="true"></b-icon>Descargar

                </b-button>

            </b-col>
        </b-row>
        <b-alert :show="dismissCountDown" dismissible variant="danger" @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            La fecha final no puede ser menor que la fecha inicial
        </b-alert>

        <b-row>
            <b-col>
                <b-form-select @input="TipoCampo()" placeholder="Tipo campo" v-model="filterByColum"
                    :options="optionst"></b-form-select>
            </b-col>
            <b-col v-if=" filterByColum == 'numero_de_identificacion' || filterByColum == 'nombre_completo'">
                <b-input v-model="filter" placeholder="Valor"></b-input>
            </b-col>
           
            <b-col v-if="filterByColum != ''">
                <b-button @click="misSolicitudes()" class="boton-busccar">
                    <b-icon class="iconobuscar" icon="search" /> Buscar
                </b-button>
            </b-col>
            <b-col v-if="filterByColum != ''">
                <b-button variant="success" @click="clearfiltros()" class="boton-busccar">
                    Limpiar
                </b-button>
            </b-col>
        </b-row>

        <b-table responsive v-if="items.length > 0 && esperandoInfo != true"  id="my-tablems"
            head-variant="light" striped :per-page="perPage" :current-page="currentPage" :items="items" :fields="fields">
            <template #cell(Ciudad)="row">
                <div class="departs">
                    <p>{{ row.item.Ciudad }}</p>
                </div>
            </template>
            <template #cell(Departamento)="row">
                <div class="departs">
                    <p>{{ row.item.Departamento }}</p>
                </div>
            </template>
            <template #cell(Acciones)="row">
                <b-row class="acciones">
                    <b-col>
                        <b-button id="tooltip-target-1" variant="info"
                            @click="verOpciones(row.item.id, row.item, row.index, items, cliente = cliente, editar = editar, proveerdor = proveerdor, carpeta = carpeta)"><b-icon
                                class="iconobuscar" icon="eye" /></b-button>
                        <b-tooltip target="tooltip-target-1" triggers="hover" placement="right">
                            Ver más
                        </b-tooltip>
                    </b-col>
                    
                    
                    
                </b-row>
            </template>
        </b-table>
        <div class="spinerr" v-if="esperandoInfo == true">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <div class="divnodata" v-if="totalfilas == 0 && esperandoInfo != true">
            <b-img class="bannernodata" src="/img/banner.jpg"></b-img>
            <p>No se encontró información</p>

        </div>
        <b-row>
            <b-col class="nombrelabel" md="2" offset-md="9">
                <label for="selectPage">Registros por página:</label>
            </b-col>
            <b-col md="1">
                <b-form-select class="selectpage" @input="paginacion(currentPage = 1)" v-model="perPage"
                    :options="pageOptions" />
            </b-col>
        </b-row>
        <b-pagination class="justify-content-center" v-model="currentPage" :total-rows="totalfilas" :per-page="perPage"
            @input="paginacion(currentPage)" aria-controls="my-tablems"></b-pagination>

        <b-modal size="xl" hide-footer centered class="modalSolicitudes" ref="modal-1" title="Histórico de estados">
            <b-alert :show="dismissCountDown1" dismissible variant="danger" @dismissed="dismissCountDown1 = 0"
                @dismiss-count-down="showAlert">
                La fecha final no puede ser menor que la fecha inicial
            </b-alert>
            <b-row class="rowhistorial">
                <b-col> <b-form-select placeholder="Tipo campo" v-model="filterByColum1"
                        :options="optionsdos"></b-form-select></b-col>
                <b-col v-if="filterByColum1 == 'observaciones'"> <b-input placeholder="Valor"
                        v-model="filter1"></b-input></b-col>
                <b-col v-if="filterByColum1 == 'estado'"> <b-form-select placeholder="Estado" v-model="filter1"
                        :options="optionss"></b-form-select></b-col>
                <b-col>

                    <b-form-datepicker id="ex-disabled-readonly" :hide-header="true" :label-help="labelhelp" :max="maxDate"
                        v-model="fechainicio1" placeholder="Fecha inicial"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="es"></b-form-datepicker>

                </b-col>

                <b-col>

                    <b-form-datepicker id="ex-disabled-readonly1" :hide-header="true" :label-help="labelhelp" :max="maxDate"
                        v-model="fechafinal1" placeholder="Fecha final"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="es"></b-form-datepicker>

                </b-col>

                <b-col v-if="filterByColum1 != 'Seleccionar una opción'">
                    <b-button @click="verModal(idSolicitud, datoactual)" class="boton-busccar">
                        <b-icon class="iconobuscar" icon="search" /> Buscar
                    </b-button>
                </b-col>
            </b-row> 
            <b-table head-variant="light" striped :per-page="perPagedos" :current-page="currentPagedos" id="my-table2"
                :items="itemsdos" :fields="fieldsdos">

            </b-table>
            <div class="divnodata" v-if="totalfilasestados == undefined">
                <b-img class="bannernodata" src="/img/banner.jpg"></b-img>
                <p>No se encontró información</p>
            </div>
            <b-pagination @input="paginacionestados(currentPagedos)" class="justify-content-center" v-model="currentPagedos"
                :total-rows="rowsdos" :per-page="perPagedos" aria-controls="my-table2"></b-pagination>
        </b-modal>

        <b-modal centered hide-footer class="modalSolicitudes " ref="modal-9" title="Visualizar">
            <b-row class="centrar">
                <b-col :offset="3"
                    :cols="3"> <b-button
                        @click="verDocumento(indexrow, itemrow, cliente, editar, proveedor, carpeta)" class="botonopciones"
                        variant="outline-primary"> <b-icon icon="eye" class="iconoopcione"></b-icon> <br>Detalle
                        solicitud</b-button></b-col>
                <b-col :cols="3"> <b-button
                        @click="verModal(idSolicitud, datoactual)" class="botonopciones" variant="outline-success"> <b-icon
                            icon="newspaper" class="iconoopcione"></b-icon><br>Historial estados</b-button></b-col>
            </b-row>
        </b-modal>
     </div>
    
 </template>
 
 <script>
 import { RepositoryFactory } from "../../repositories/RepositoryFactory";
 import Vue from 'vue'
 import VueFormGenerator from 'vue-form-generator'
 import 'vue-form-generator/dist/vfg.css'
 import TableGeneral from "../../components/Table.vue";
 import HeaderGeneral from "../../components/HeaderGeneral.vue";
 import "vue-form-generator/dist/vfg-core.css";
 import * as XLSX from 'xlsx';

 
 
 Vue.use(VueFormGenerator)
 
 const config = RepositoryFactory.get("config");
 const clientes = RepositoryFactory.get("clientes");
 export default {
     components: {
         "vue-form-generator": VueFormGenerator.component,
         TableGeneral,
         HeaderGeneral
     },
     data() {
         return {
            dismissCountDown: 0,
            dismissCountDown1: 0,
            typeOrder: "desc",
            items:[],
            datosExcel:[],
            nombreEntidad: "entidad_paciente",
            idVersion: 2,
            column: "id",
            perPage: 5,
            currentPage: 1,
             vista:"Histórico de pacientes",
             proveniente:" - Histórico de pacientes",
             carpeta:"Prestadores",
             filterByColum: null,
            filter: "",
             esperandoInfo: false,
             totalfilas: null,
            totalfilasestados: null,
            filterByColum1: null,
            cliente: false,
            editar: false,
            proveerdor: false,
            idSolicitud: null,
            datoactual: null,
            indexrow: null,
            itemrow: null,
            proveedor: false,
            fieldsdos: ['Fecha', 'Estado', 'Observación'],
            fieldsdosvalor: ['Fecha', 'Observación'],
            itemsdos: [{ isActive: true, Fecha: '26-10-2023', Estado: 'Nuevo', 'Observación': 'Esto es una prueba' },
            { isActive: true, Fecha: '26-10-2023', Estado: 'Nuevo', 'Observación': 'Esto es una prueba' },
            { isActive: true, Fecha: '26-10-2023', Estado: 'Nuevo', 'Observación': 'Esto es una prueba' },
            ],
            pageOptions: [3, 5, 10, 15, 20],
            currentPage: 1,
            perPagedos: 5,
            currentPagedos: 1,
            rowsdos: 0,
            optionsdos: [
                { value: null, text: 'Seleccionar' },
                { value: 'observaciones', text: 'Observación' },
                { value: 'estado', text: 'Estado' }
            ],
            maxDate: this.getToday(),
            fechainicio: "",
            fechafinal: "",
            fechainicio1: "",
            fechafinal1: "",
            labelhelp: "Utilice las teclas del cursor para navegar por las fechas del calendario",
             optionst: [{ value: null, text: 'Seleccionar' },  { value: 'numero_de_identificacion', text: 'Documento' }, { value: 'nombre_completo', text: 'Paciente' },],
             optionss: [
             { value: null, text: 'Seleccionar' },
                { value: '1', text: 'Nuevo' },
                { value: '3', text: 'En solicitud' },
                { value: '5', text: 'Solicitud tomada' },
                { value: '6', text: 'Proceso de entrega' },
                  { value: '7', text: 'Entregado' },
                { value: '8', text: 'Fallo de entrega' },
                { value: '12', text: 'Segundo intento de entrega' },
                { value: '5', text: 'Solicitud retiro' },
                { value: '2', text: 'Rechazado' },
                { value: '10', text: 'Finalizado' },
                { value: '11', text: 'Cancelado' },

            ],
            fields: [{ key: 'Tipo documento', sortable: true },
              { key: 'Documento paciente', sortable: true },
               { key: 'Paciente', sortable: true }, 
               { key: 'Cantidad solicitudes', sortable: true },
               { key: 'Solicitudes activas', sortable: true },
               'Acciones'],  
            condicionales: {
                "AND": [
                    {
                        "id": {
                            "notEquals": ""
                        }
                    },


                ]
            }, 
            relaciones: [
            {
                "entidad":{
                    "nombre":"entidad_solicitud",
                    "columna_relacion":"id_paciente",
                    "columna_relacion_principal":"id",
                    "order":{
                        "column":"col",
                        "type":"asc"
                    },
                    "size":5,
                    "page":1,
                    "where":[
                        {
                            "AND":[
                                {
                                    "id":{
                                        "notEquals":""
                                    }
                                }
                            ]
                        }
                    ]
                }
            },
            {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "id" },
                        "columna_relacion_principal": "tipo_de_identificacion",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 6,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "Tipos_documento"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                
            ],
         }
 
     },
     computed: {
        rows() {
            return this.totalfilas
        },
        rowsdos() {
            return this.totalfilasestados
        }
    },
     async created() {
        this.misSolicitudes();
     },
     methods: {
        TipoCampo() {
            this.fechainicio = "";
            this.fechafinal = "";
            this.filter = "";
            this.selectedd = null
        },
        getToday() {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Establecer la hora a las 00:00:00:00 para evitar problemas de zona horaria.
            return today.toISOString().slice(0, 10);
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        clearfiltros() {
            this.$router.go();
        },
        verOpciones(id, item, index, items, cliente, editar, proveerdor, carpeta) {
            this.idSolicitud = id;
            this.datoactual = item;
            this.indexrow = index;
            this.itemrow = items;
            this.$refs['modal-9'].show();
        },
        verDocumento(index, item, cliente, editar, proveedor, carpeta) {
            // Implementar navegación a detalle del paciente
            console.log('Ver documento', item);
        },
        verModal(idSolicitud, datoactual) {
            // Implementar modal de historial
            console.log('Ver modal historial', idSolicitud);
            this.$refs['modal-1'].show();
        },
        showAlert(dismissCountDown1) {
            this.dismissCountDown1 = dismissCountDown1

        },
        async misSolicitudes(){
            try {
            this.esperandoInfo = true;
            // var where = [this.condicionales];
            var where = JSON.parse(JSON.stringify([this.condicionales]));
            if (this.filterByColum && this.filter) {
                    where[0]['AND'].push({
                        [this.filterByColum]: {
                            "iLike": this.filter
                        }
                    })
                }
            var params = {
                        "nombreEntidad": this.nombreEntidad,
                        "idVersion": this.idVersion,
                        "column": this.column,
                        "type": this.typeOrder,
                        "size": this.perPage,
                        "page": this.currentPage,
                    }
                    const response = await config.getMetaData(params, where,this.relaciones);
                    this.esperandoInfo = false;
                    this.totalfilas = response.message.count
                    this.items = [];
                    var cantidad = this.perPage;
                   
                    if(response.message =='Error no se encontró datos'){
                        this.totalfilas=0;
                    }

                    var dataexcel=[]
                    var estadosE = response.message.rows;
                    var cantidadReal = estadosE ? estadosE.length : 0;
                    
                    for (var i = 0; i < cantidadReal; i++) {
                        var numeracion = ((this.currentPage - 1) * this.perPage) + i;
                        
                        if (!estadosE[i] || !estadosE[i]['data']) {
                            continue;
                        }
                        
                        var dataTable = estadosE[i]['data'];

                        const objetoBuscado = dataTable.listados.flat().find(item => item.row_data && item.row_data.id === 1 && item.nombre_lista === "Tipos_documento");
                        const nameResultado = objetoBuscado ? objetoBuscado.row_data.name : null;
                        
                        const cantidadSolicitudes = dataTable.entidad_solicitud && dataTable.entidad_solicitud[0] ? dataTable.entidad_solicitud[0].length : 0;
                        const cantidadSolicitudesactivas = dataTable.entidad_solicitud && dataTable.entidad_solicitud[0] ? dataTable.entidad_solicitud[0] : [];
                        
                        console.log("esteeess cantidadSolicitudesactivas",cantidadSolicitudesactivas)
                        let contadorEstado1 = 0;
                        cantidadSolicitudesactivas.forEach(item => {
                            if (item && item.data && item.data.estado === 7) {
                                contadorEstado1++;
                            }
                        });

                        console.log("esteeess",contadorEstado1)
                        this.items[numeracion] = {
                            'Tipo documento': nameResultado,
                            'Documento paciente': dataTable.numero_de_identificacion,
                            'Paciente': dataTable.nombre_completo,
                            "Cantidad solicitudes": cantidadSolicitudes,
                            "Solicitudes activas": contadorEstado1,
                            'id': dataTable.id
                        };
                    }  
            } catch (error) {
                if (error.response.data.mensaje == 'Token inválido') {
                    localStorage.clear();
                    return this.$router.push("/error401");
                }
            }
        },
        async descargar() {
            this.esperandoInfo = true;
            try {
                // Construir las condiciones de filtro
                var where = JSON.parse(JSON.stringify([this.condicionales]));
                if (this.filterByColum && this.filter) {
                    where[0]['AND'].push({
                        [this.filterByColum]: {
                            "iLike": this.filter
                        }
                    })
                }

                // Obtener TODOS los registros filtrados (sin paginación)
                var params = {
                    "nombreEntidad": this.nombreEntidad,
                    "idVersion": this.idVersion,
                    "column": this.column,
                    "type": this.typeOrder,
                    "size": 10000, // Obtener muchos registros para exportar
                    "page": 1,
                    "typeOrder": this.typeOrder
                }
                
                const response = await config.getMetaData(params, where, this.relaciones);
                
                if (response.message && response.message.rows) {
                    var dataExcelFiltrada = [];
                    var estadosE = response.message.rows;
                    
                    // Procesar todos los registros filtrados
                    for (var i = 0; i < estadosE.length; i++) {
                        var dataTable = estadosE[i]['data'];
                        
                        const objetoBuscado = dataTable.listados.flat().find(item => item.row_data && item.row_data.id === 1 && item.nombre_lista === "Tipos_documento");
                        const nameResultado = objetoBuscado ? objetoBuscado.row_data.name : null;
                        const cantidadSolicitudes = dataTable.entidad_solicitud[0].length;
                        const cantidadSolicitudesactivas = dataTable.entidad_solicitud[0];
                        
                        let contadorEstado1 = 0;
                        cantidadSolicitudesactivas.forEach(item => {
                            if (item.data.estado === 7) {
                                contadorEstado1++;
                            }
                        });
                        
                        // Construir objeto para Excel con los datos procesados
                        dataExcelFiltrada.push({
                            'Tipo documento': nameResultado,
                            'Documento paciente': dataTable.numero_de_identificacion,
                            'Paciente': dataTable.nombre_completo,
                            "Cantidad solicitudes": cantidadSolicitudes,
                            "Solicitudes activas": contadorEstado1
                        });
                    }
                    
                    // Usar los datos filtrados para el Excel
                    const jsonData = dataExcelFiltrada.length > 0 ? dataExcelFiltrada : this.items;
                    
                    // Crear un nuevo libro de trabajo de Excel
                    const workbook = XLSX.utils.book_new();
                    const worksheet = XLSX.utils.json_to_sheet(jsonData);
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Histórico Pacientes');
                    
                    // Convertir el libro de trabajo a un Blob
                    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
                    
                    // Crear un enlace para descargar el archivo
                    const url = window.URL.createObjectURL(data);
                    const link = document.createElement('a');
                    link.href = url;
                    
                    // Generar nombre de archivo con fecha actual
                    const fecha = new Date();
                    const nombreArchivo = `historico_pacientes_${fecha.getFullYear()}${(fecha.getMonth()+1).toString().padStart(2,'0')}${fecha.getDate().toString().padStart(2,'0')}.xlsx`;
                    link.setAttribute('download', nombreArchivo);
                    document.body.appendChild(link);
                    
                    // Simular un clic en el enlace para descargar el archivo
                    link.click();
                    
                    // Eliminar el enlace del DOM
                    document.body.removeChild(link);
                    
                    this.esperandoInfo = false;
                } else {
                    // Si no hay respuesta, usar datos actuales de la tabla
                    const jsonData = this.items;
                    const workbook = XLSX.utils.book_new();
                    const worksheet = XLSX.utils.json_to_sheet(jsonData);
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Histórico Pacientes');
                    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
                    const url = window.URL.createObjectURL(data);
                    const link = document.createElement('a');
                    link.href = url;
                    const fecha = new Date();
                    const nombreArchivo = `historico_pacientes_${fecha.getFullYear()}${(fecha.getMonth()+1).toString().padStart(2,'0')}${fecha.getDate().toString().padStart(2,'0')}.xlsx`;
                    link.setAttribute('download', nombreArchivo);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.esperandoInfo = false;
                }
            } catch (error) {
                console.error('Error al descargar:', error);
                this.esperandoInfo = false;
                
                // En caso de error, usar los datos actuales
                const jsonData = this.items;
                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(jsonData);
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Histórico Pacientes');
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'historico_pacientes.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        paginacion(page) {
            this.currentPage = page;
            this.misSolicitudes();
        },
        paginacionestados(page) {
            this.currentPagedos = page;
            // Aquí iría la lógica para paginar los estados del modal
        }
     }
 };
 </script>
 <style>
 </style>

